<!--
  - Copyright (c) 2019 brightlamp
  -->

<template>
    <div>
        <v-navigation-drawer v-model="drawer" fixed app>
            <v-list>
                    <div v-if="showActionMenuItems">
                    <v-list-item :to="{ name: 'Home' }" ripple exact>
                        <v-list-item-action>
                            <v-icon>mdi-home</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Home</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'Patient ID Test Results' }" ripple exact>
                        <v-list-item-action>
                            <v-icon>mdi-clipboard-text</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Trending & Exports</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item :to="{ name: 'Export Patient ID Test Results List' }" ripple exact>
                        <v-list-item-action>
                            <v-icon>mdi-cloud-download</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Exported Tests History</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="currentUser && currentUser.isProUser && currentUser.orgId" :to="{ name: 'Telehealth Dashboard' }" ripple exact>
                        <v-list-item-action>
                            <v-icon>mdi-card-account-phone</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Telehealth Dashboard</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider/>
                    <v-list-item v-if="currentUser && currentUser.authorities && currentUser.authorities[0].role === 'ROLE_ADMIN'" :to="{ name: 'ResearchTests' }" ripple>
                        <v-list-item-action>
                            <v-icon>mdi-file-find</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Research Tests</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="currentUser && currentUser.authorities && (currentUser.authorities[0].role === 'ROLE_ORG_ADMIN' || currentUser.authorities[0].role === 'ROLE_ADMIN')" :to="{ name: 'Orgs' }" ripple>
                        <v-list-item-action>
                            <v-icon>mdi-city</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Orgs</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="currentUser && currentUser.authorities && currentUser.authorities[0].role === 'ROLE_ADMIN'" :to="{ name: 'Users' }" ripple>
                        <v-list-item-action>
                            <v-icon>mdi-human-male-female</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Users</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="currentUser && currentUser.authorities && currentUser.authorities[0].role === 'ROLE_ADMIN'" :to="{ name: 'Message Center Admin', params: { admin: true } }" ripple exact>
                        <v-list-item-action>
                            <v-icon>mdi-email-edit</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Message Center Admin</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item v-if="currentUser && currentUser.authorities && currentUser.authorities[0].role === 'ROLE_ADMIN'" @click="openSendMessage()" ripple>
                        <v-list-item-action>
                            <v-icon>mdi-message-text-outline</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Send Message</v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                    <v-divider/>
                </div>
                <v-list-item :to="{ name: 'Message Center' }" ripple exact>
                    <v-list-item-action>
                        <v-icon>mdi-email</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            Message Center
                            <v-badge
                                :value = "totalUnviewedMessages"
                                :color="totalUnviewedMessages ? 'red' : 'white'"
                                :content="totalUnviewedMessages">
                            </v-badge>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item :to="{ name: 'Settings' }" ripple>
                    <v-list-item-action>
                        <v-icon>mdi-account-settings</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Settings</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item @click="toggleLogoutDialog()" ripple>
                    <v-list-item-action>
                        <v-icon>mdi-exit-to-app</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Logout</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-list-item disabled>
                    <v-list-item-content>
                        <v-list-item-title>Version 2.5.0</v-list-item-title>
                        <v-list-item-title>&copy; 2024 brightlamp</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
        <toolbar></toolbar>
        <ConfirmationDialog v-if="logoutDialog" :params="logoutParams" @confirmation-dialog-response="logout"></ConfirmationDialog>
        <SendMessageDialog :dialog="sendMessageDialog" :orgName="'All Users'" :orgId="null" @dialog-close="closeSendMessage"/>
    </div>
</template>

<script>
    import toolbar from './toolbar'
    import SendMessageDialog from '@/components/send-message-dialog'
    import ConfirmationDialog from '@/components/confirmation-dialog'
    import { mapMutations, mapState, mapActions } from 'vuex'

    export default
    {
        name: 'navigation-drawer',
        components:
        {
            toolbar,
            SendMessageDialog,
            ConfirmationDialog
        },
        data()
        {
            return {
                logoutDialog: false,
                sendMessageDialog: false,
                logoutParams:
                {
                    title: 'Logout of Reflex',
                    text: 'Are you sure you want to logout?',
                    positiveResponse: 'Yes',
                    negativeResponse: 'No'
                },
                timer: ''
            }
        },
        computed:
        {
            ...mapState('auth',
            {
                currentUser: state => state.currentUser,
                _drawer: state => state.navDrawerToggle
            }),
            ...mapState('messages',
            {
                totalUnviewedMessages: state => state.totalUnviewedMessages
            }),
            drawer:
            {
                get: function()
                {
                    return this._drawer
                },
                set: function(newValue)
                {
                    this.SET_NAV_DRAWER_TOGGLE(newValue)
                }
            },
            showActionMenuItems: function()
            {
                if (this.currentUser && !this.currentUser.profileNeeded)
                {
                    if (!this.currentUser.orgId && (this.currentUser.stripeSubscription || this.currentUser.appleSubscription))
                    {
                        // Don't show action menu items for critical care users
                        if (("2" === this.currentUser.stripeSubscription.subscriberLevel || "2e" === this.currentUser.stripeSubscription.subscriberLevel) ||
                            ("2" === this.currentUser.appleSubscription.subscriberLevel || "2e" === this.currentUser.appleSubscription.subscriberLevel))
                        {
                            return false
                        }
                    }
                    return true
                }
                // Don't show action menu items for users who have not completed their profile setup
                return false
            }
        },
        created()
        {
            this.fetchUnviewedMessageCount();
            this.timer = setInterval(this.fetchUnviewedMessageCount, 300000)
        },
        beforeDestroy()
        {
            clearInterval(this.timer)
        },
        methods:
        {
            ...mapMutations('auth', ['SET_NAV_DRAWER_TOGGLE']),
            ...mapMutations('common', ['WAITING', 'SHOW_SNACKBAR_ERROR', 'HIDE_SNACKBAR']),
            ...mapActions('auth', ['LOGOUT_AUTH']),
            ...mapActions('messages', ['GET_UNVIEWED_MESSAGE_COUNT']),
            toggleLogoutDialog()
            {
                this.logoutDialog = !this.logoutDialog
            },
            async logout(payload)
            {
                // If the user chose to not logoff
                if (!payload.response)
                {
                    this.toggleLogoutDialog();
                    return
                }
                this.HIDE_SNACKBAR();
                try
                {
                    await this.LOGOUT_AUTH();
                    this.WAITING(false);
                    try
                    {
                        await this.$router.replace(
                        {
                            name: 'Login'
                        })
                    }
                    catch {}
                }
                catch (error)
                {
                    this.SHOW_SNACKBAR_ERROR(error.message)
                }
            },
            openSendMessage()
            {
                this.sendMessageDialog = true;
                this.SET_NAV_DRAWER_TOGGLE(false)
            },
            closeSendMessage()
            {
                this.sendMessageDialog = false;
                this.SET_NAV_DRAWER_TOGGLE(true)
            },
            fetchUnviewedMessageCount()
            {
                this.GET_UNVIEWED_MESSAGE_COUNT().catch()
            }
        }
    }
</script>

<style scoped>
</style>